export default __webpack_public_path__ + "static/media/bg-coupon-uncollected.fadd33f0.png";